<SettingsLayout page='settings/hotkeys' label="Hotkeys">
  <h1>Hotkeys</h1>

  <h2 class="sr-only">Preferences</h2>
  <form class="ui-settings" aria-label="Hotkey settings">
    <label class="setting-group {allowChangeHotkeySetting ? '' : 'disabled-style'}">
      <input type="checkbox" id="choice-disable-hotkeys"
             bind:checked="$disableHotkeys"
             on:change="onChange()"
             disabled={!allowChangeHotkeySetting}
      >
      Disable all hotkeys
    </label>
    <label class="setting-group  {allowChangeLeftRightSetting ? '' : 'disabled-style'}">
      <input type="checkbox" id="choice-left-right-focus"
             bind:checked="$leftRightChangesFocus"
             on:change="onChange()"
             disabled={!allowChangeLeftRightSetting}
      >
      Left/right arrow keys change focus rather than columns/media
    </label>
  </form>

  <h2 class="sr-only">Guide</h2>

  <ShortcutHelpInfo />
</SettingsLayout>
<UISettingsStyles />
<style>
  .ui-settings {
    margin-bottom: 20px;
  }

  label.disabled-style {
    color: var(--deemphasized-text-color);
  }
</style>
<script>
  import SettingsLayout from '../../_components/settings/SettingsLayout.html'
  import ShortcutHelpInfo from '../../_components/ShortcutHelpInfo.html'
  import { store } from '../../_store/store.js'
  import { isKaiOS } from '../../_utils/userAgent/isKaiOS.js'
  import UISettingsStyles from '../../_components/settings/UISettingsStyles.html'

  export default {
    store: () => store,
    data: () => ({
      allowChangeHotkeySetting: !isKaiOS() // In general KaiOS users cannot change this because they need the hotkeys
    }),
    computed: {
      allowChangeLeftRightSetting: ({ $disableHotkeys }) => (
        !$disableHotkeys && !isKaiOS()
      )
    },
    methods: {
      onChange () {
        this.store.save()
      }
    },
    components: {
      SettingsLayout,
      ShortcutHelpInfo,
      UISettingsStyles
    }
  }
</script>
